import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { CardView, rem } from 'design-system';
import { AppView } from 'design-system/AppView';
import EmptyComponent from 'design-system/EmptyComponent';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import StatusBar from 'design-system/StatusBar';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../constants';
import { getPropertyName } from '../constants';
const strings = {
    subtitle: 'Tell us if the value has changed since your purchase',
    no: 'No, it hasn’t',
    yes: 'Yes, it has',
};
const HasValuationChangedScreen = ({ navigation, route, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const title = useMemo(() => `Has the ${getPropertyName(route.params.type).toLowerCase()} valuation changed?`, [route.params.type]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            ...(isWeb && {
                title,
                headerTitle: EmptyComponent,
            }),
        });
    }, [colors.text.primary, title]);
    const routeParams = useMemo(() => ({
        ...(route.params || {}),
        keyBack: route.params?.keyBack || route.key,
    }), [route.params, route.key]);
    const onNo = useCallback(() => {
        navigation.navigateDeprecated('DummyAccountCreated', {
            ...routeParams,
            balance: route.params.initialValue,
            initialValue: undefined,
        });
    }, [routeParams, route.params.initialValue]);
    const onYes = useCallback(() => {
        navigation.push('AddBalance', routeParams);
    }, [routeParams]);
    return (<AppView type="secondary" paddingBottom isInTab={isWeb} avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <ScreenInfoHeader title={title} subTitle={strings.subtitle}/>
      <CardView noMarginTop>
        <SettingsItemNavigate title={strings.no} onPress={onNo} style={styles.containerPadding}/>
      </CardView>
      <CardView noMarginTop>
        <SettingsItemNavigate title={strings.yes} onPress={onYes} style={styles.containerPadding}/>
      </CardView>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    centered: {
        alignSelf: 'center',
    },
    containerPadding: {
        ...(isWeb && {
            padding: rem(8),
        }),
    },
}));
export default HasValuationChangedScreen;
